// 拉取配置的开关值定义
export const SWITCH_STATE = {
    NONE: 0, // 未设置
    ON: 1, // 开关打开
    OFF: 2, // 开关关闭
};

// 所有开关项
export enum SWITCH_KEY {
    SLIDE_OCR_ENTRY = 'SLIDE_OCR_ENTRY',
    PPT_HIGHLIGHT_TITLE = 'PPT_HIGHLIGHT_TITLE',
    SLIDE_NICK_NAMEPLATE = 'SLIDE_NICK_NAMEPLATE',
    SLIDE_AUTO_LAYOUT_CHECK_ENTRY = 'SLIDE_AUTO_LAYOUT_CHECK_ENTRY', // 排版检查入口自动打开
}

// 在平台的项目设置-环境管理中可看到对应的测试环境id，默认测试环境为1，正式环境为空
export const SWITCH_ENV_ID = {
    DEFAULT: '1',
};
